import Service from "../../AuthService";
const factoryEmployeeSale = {
    getFactoryEmployeeSale(page,data){
        return Service.get('/factory_employee_sale?page='+page+
            '&factory_id='+data.factory_id+
            '&start_date='+data.start_date+
            '&end_date='+data.end_date+
            '&rc_number='+data.rc_number+
            '&employee='+data.employee
        );
    },
    showFactoryEmployeeSale(id){
        return Service.get('/factory_employee_sale/'+id);
    },
    createFactoryEmployeeSale(data){
        return Service.post('/factory_employee_sale',data);
    },
    updateFactoryEmployeeSale(id,data){
        return Service.put('/factory_employee_sale/'+id,data);
    },
    deleteFactoryEmployeeSale(id){
        return Service.delete('/factory_employee_sale/'+id);
    },
    generateRCNumber(){
        return Service.get('/generate_rc_number');
    }
}
export default factoryEmployeeSale
